import { MouseEvent, TouchEvent, useRef } from 'react';

function isTouchEvent(e: MouseEvent | TouchEvent): e is TouchEvent {
  return (e as TouchEvent).changedTouches !== undefined;
}

function useDraggable<T extends HTMLElement>() {
  const sliderRef = useRef<T>(null);
  let mouseDown = false;
  let startX: number;
  let scrollLeft: number;

  const startDragging = (e: MouseEvent<T> | TouchEvent<T>) => {
    if (!sliderRef || !sliderRef.current) return;

    mouseDown = true;
    const pageX = isTouchEvent(e) ? e.changedTouches[0].pageX : e.pageX;
    startX = pageX - sliderRef.current.offsetLeft;
    scrollLeft = sliderRef.current.scrollLeft;
  };

  const stopDragging = () => {
    mouseDown = false;
  };

  const inDragging = (e: MouseEvent<T> | TouchEvent<T>) => {
    e.preventDefault();

    if (!sliderRef || !sliderRef.current || !mouseDown) return;

    const pageX = isTouchEvent(e) ? e.changedTouches[0].pageX : e.pageX;
    const x = pageX - sliderRef.current.offsetLeft;
    const scroll = x - startX;
    sliderRef.current.scrollLeft = scrollLeft - scroll;
  };

  return { sliderRef, startDragging, stopDragging, inDragging };
}

export default useDraggable;
